import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent} from 'react'
import clsx from 'clsx'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {cloudfrontBaseUrl} from '~/utils/constants'

const BlackFridayInfo: FunctionComponent = () => {
  const {language, domain, locale, featureFlags} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {domainName} = getDomainConfig(domain, locale)

  const isBestReviews = domainName === 'bestreviews'

  const iconUrl = `${cloudfrontBaseUrl}/black-friday/present_icon.png`
  const logoUrl = `${cloudfrontBaseUrl}/black-friday/black_friday.png`
  const logoWeekUrl = `${cloudfrontBaseUrl}/black-friday/black_friday_week_is_here.png`
  const logoMobileShortUrl = `${cloudfrontBaseUrl}/black-friday/black_friday_mobile_short.png`
  const blackFridayType = featureFlags?.blackFridayType ?? 'event'

  return (
    <div
      className={clsx(
        'mx-auto flex flex-row items-center gap-1',
        blackFridayType === 'week' && 'mobile:flex-row-reverse',
      )}
    >
      <div className={clsx('h-[28px] w-[40px] mobile:h-[18px] mobile:w-[28px]', !isBestReviews && 'mobile:hidden')}>
        <img src={iconUrl} alt="black friday icon" className="h-[28px] w-[40px] mobile:h-[18px] mobile:w-[28px]" />
      </div>
      <div className="flex flex-row items-center gap-1 mobile:flex-col mobile:gap-0 [&>div]:mx-auto">
        <div className="h-[24px] w-[109px] mobile:hidden mobile:h-[18px] mobile:w-[82px]">
          <img src={logoUrl} alt="black friday logo" className="h-[24px] w-[109px] mobile:h-[18px] mobile:w-[82px]" />
        </div>
        {blackFridayType === 'week' ? (
          <div
            className={clsx(
              isBestReviews
                ? 'hidden mobile:block mobile:h-[28px] mobile:w-[81px] [&>img]:mobile:h-[28px] [&>img]:mobile:w-[81px]'
                : 'hidden mobile:block mobile:h-[28px] mobile:w-[39px] [&>img]:mobile:h-[28px] [&>img]:mobile:w-[39px]',
            )}
          >
            <img src={isBestReviews ? logoWeekUrl : logoMobileShortUrl} alt="black friday logo" />
          </div>
        ) : (
          <div
            className={clsx(
              isBestReviews
                ? 'hidden mobile:block mobile:h-[18px] mobile:w-[82px] [&>img]:mobile:h-[18px] [&>img]:mobile:w-[82px]'
                : 'hidden mobile:block mobile:h-[28px] mobile:w-[39px] [&>img]:mobile:h-[28px] [&>img]:mobile:w-[39px]',
            )}
          >
            <img src={isBestReviews ? logoUrl : logoMobileShortUrl} alt="black friday logo" />
          </div>
        )}

        <span
          className={clsx(
            'text-base font-medium mobile:-mt-1 mobile:text-sm',
            blackFridayType === 'week' && 'mobile:hidden',
            !isBestReviews && 'hidden',
          )}
        >
          {translations.BlackFriday.isHere(blackFridayType)}
        </span>
      </div>
    </div>
  )
}

export default BlackFridayInfo
